import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { serviceUrl } from '../config'
import { Cookies } from 'react-cookie'

export const mailTemplateApi = createApi({
    reducerPath: 'mailTemplateApi',
    baseQuery: fetchBaseQuery({
        baseUrl: serviceUrl,
        prepareHeaders: (headers) => {

            const token = new Cookies().get('token');

           if (token) {
             headers.set('authorization', `Bearer ${token}`)
           }
           return headers
        }
    }),
    tagTypes: ['mailTemplate'],
    endpoints: (builder) => ({
        mailTemplate: builder.query({
            query: (arg) => {

                if(arg==undefined){
                    return { url: '/mailTemplate/', method: 'GET' }
                } else {
                    return { url: `/mailTemplate/${arg}`, method: 'GET' }
                }
            },

        }),
        addMailTemplate: builder.mutation({
            query: (page) => ({
                url: '/mailTemplate/',
                method: 'POST',
                body: page
            }),
            invalidatesTags: ['mailTemplate']
        }),
        updateMailTemplate: builder.mutation({
            query: ({ id, rest }) => ({
                url: `/mailTemplate/${id}`,
                method: 'PUT',
                body: rest
            }),
            invalidatesTags: ['mailTemplate']
        }),
        deleteMailTemplate: builder.mutation({
            query: (id) => ({
                url: `/mailTemplate/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['mailTemplate']
        })
    })
});

export const { useMailTemplateQuery, useAddMailTemplateMutation, useUpdateMailTemplateMutation, useDeleteMailTemplateMutation } = mailTemplateApi;
